module.exports = __webpack_public_path__ + "img/add-to-jobs-white.d4894214.svg";